import { Switch, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import { ImportContextProvider } from "../contexts/import.context";
import lightTheme from "../styles/light-theme";
import PrivateRoutes from "./PrivateRoutes";
import CurrentRoutes from "./CurrentRoutes";
import GlobalStyles from "../styles/global";
import {
  LoginView,
  CadastrarEmpresaView,
  CadastrarContadorView,
  LoadingView,
  NotFoundView,
  AgendamentoServicoPublicoView,
} from "../views";

const Routes = () => {
  const location = useLocation();
  let scroll = location.pathname.includes("relatorios");

  const getCurrentRoutes = () => CurrentRoutes;

  return (
    <ThemeProvider theme={lightTheme}>
      <ImportContextProvider>
        <GlobalStyles themeMode={lightTheme} scroll={scroll} />
        <Switch>
          <Route
            render={(matchProps) => (
              <CadastrarEmpresaView {...matchProps}></CadastrarEmpresaView>
            )}
            path="/cadastros/empresa"
          />
          <Route
            render={(matchProps) => (
              <CadastrarContadorView {...matchProps}></CadastrarContadorView>
            )}
            path="/cadastros/contador"
          />
          <Route
            exact={true}
            render={(matchProps) => <LoadingView {...matchProps}></LoadingView>}
            path="/"
          />
          {/* <Route
            render={(matchProps) => <LoadingView {...matchProps}></LoadingView>}
            path="/loading"
          /> */}
          <Route
            render={(matchProps) => <LoginView {...matchProps}></LoginView>}
            path="/login"
          />
          <Route
            render={(matchProps) => (
              <AgendamentoServicoPublicoView
                {...matchProps}
              ></AgendamentoServicoPublicoView>
            )}
            path="/cadastros/agendamento-servico/:id"
          />
          {getCurrentRoutes().map((route) => (
            <PrivateRoutes
              key={route.path}
              component={route.component}
              layout={route.layout}
              path={route.path}
              title={route.title}
              exact={route.exact}
            />
          ))}
          <Route render={() => <NotFoundView />} />
        </Switch>
      </ImportContextProvider>
    </ThemeProvider>
  );
};

export default Routes;
